import React from 'react'
import classnames from 'classnames/bind'

// Using CSS Modules so we assign the styles to a variable
import s from './App.styl'
const cx = classnames.bind(s)
import { sounds } from './sounds'

import dayVideo from './day_in_the_life.mp4'

// Favicon link is in the template, this just makes webpack package it up for us
import './favicon.ico'

// trash bot images
import powerUpBot from './power_up.png'
import warningBot from './warning.png'
import eatingBot from './eating.png'
import powerDownBot from './power_down.png'

import noSound from './no_sound.png'

import chevron from './chevron.png'
import chevronYr from './chevron-yr.png'
import chevronWr from './chevron-wr.png'

import powerUpAnim from './powerUp.gif'
import warningAnim from './warning.gif'
import eatingAnim from './eating.gif'
import powerDownAnim from './powerDown.gif'

const trashBots = {
  powerUp: {
    bot: powerUpBot,
    anim: powerUpAnim,
    y: -357,
  },
  warning: {
    bot: warningBot,
    anim: warningAnim,
    y: -357,
  },
  eating: {
    bot: eatingBot,
    anim: eatingAnim,
    y: -461,
  },
  powerDown: {
    bot: powerDownBot,
    anim: powerDownAnim,
    y: -584,
  },
}

const initialState = {
  uri: 'home',
  inactive: false,
  powerUp: {
    melody: null,
    ambience: null,
    effect: null,
  },
  warning: {
    melody: null,
    ambience: null,
    effect: null,
  },
  eating: {
    melody: null,
    ambience: null,
    effect: null,
  },
  powerDown: {
    melody: null,
    ambience: null,
    effect: null,
  },
}

export class Link extends React.Component {
  render () {
    return (
      <div className={this.props.className} onClick={(e) => this.props.setUri(this.props.to)}>
        {this.props.children}
      </div>
    )
  }
}

export class Home extends React.Component {
  render () {
    return (
      <div className={cx('client')}>
        <div className={cx('home')}>
          <div style={{margin: '50px', fontSize: '60px', fontWeight: '900'}}>WELCOME!</div>
          <div style={{fontSize: '40px', fontWeight: '400'}}>Trash Bot is a street-cleaning machine.</div>
          <div style={{fontSize: '40px', fontWeight: '400'}}>What sounds should Trash Bot make during a day of work?</div>
        </div>
        <Link {...this.props} to='power_up'>
          <div className={cx('start_designing_button')}>
            <div>Start Designing</div>
          </div>
        </Link>
      </div>
    )
  }
}

export class Progress extends React.Component {
  render () {
    const styleFor = (key) => (
      this.props.scene === key ? cx('progress-active') : cx('progress-inactive')
    )
    const chevronFor = (key, nextKey) => {
      if (this.props.scene === key) {
        return chevronYr
      }
      if (this.props.scene === nextKey) {
        return chevronWr
      }
      return chevron
    }
    const chevronStyle = {
      height: '85px',
      float: 'right',
      marginTop: '-20px',
    }
    return <div className={cx('client-progress')}>
      <Link {...this.props} to='power_up' className={styleFor('powerUp')}>
        <img src={chevronFor('powerUp', 'warning')} style={chevronStyle} />
        <div>1. Power Up</div>
      </Link>
      <Link {...this.props} to='warning' className={styleFor('warning')}>
        <img src={chevronFor('warning', 'eating')} style={chevronStyle} />
        <div>2. Warning</div>
      </Link>
      <Link {...this.props} to='eating' className={styleFor('eating')}>
        <img src={chevronFor('eating', 'powerDown')} style={chevronStyle} />
        <div>3. Feed The Bot</div>
      </Link>
      <Link {...this.props} to='power_down' className={styleFor('powerDown')}>
        <div>4. Power Down</div>
      </Link>
    </div>
  }
}

export class MixButton extends React.Component {
  render () {
    const styled = () => (
      this.props.getSounds()[this.props.scene][this.props.channel] === this.props.sound
        ? cx('mix-target-selected', 'playable')
        : cx('mix-target', 'playable')
      )
    const playSample = () => {
      this.props.setSound(this.props.scene, this.props.channel, this.props.sound)
    }
    return <div className={cx('mix-button')}>
      <div
        className={styled()}
        onClick={playSample}>{this.props.sound}
      </div>
    </div>
  }
}

export class MixRow extends React.Component {
  play () {
    const mixButton = this.props.getSounds()[this.props.scene][this.props.channel]
    if (mixButton) {
      this.refs[mixButton].play()
    }
  }
  render () {
    const cancel = () => {
      this.props.setSound(this.props.scene, this.props.channel, null)
    }
    const cancelButton = () => (
      this.props.getSounds()[this.props.scene][this.props.channel]
        ? <div className={cx('mix-target', 'unplayable')} onClick={cancel}><img src={noSound} style={{width: '40px', height: '40px'}} /></div>
        : null
    )
    return <div className={cx('mix-row')}>
      <div className={cx('mix-title')}>{this.props.prompt}</div>
      <MixButton ref='a' {...this.props} sound='a' />
      <MixButton ref='b' {...this.props} sound='b' />
      <div className={cx('mix-button')}>
        {cancelButton()}
      </div>
    </div>
  }
}

export class Scene extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      animating: false,
    }
  }
  animate = () => {
    this.setState({animating: true})
    setTimeout(() => {
      this.setState({animating: false})
    }, 3000)
  }
  render () {
    return (
      <div className={cx('client')}>
        <Progress {...this.props} scene={this.props.scene} />
        <div className={cx('interactive-page')}>
          <div className={cx('mix-column')}>
            <div className={cx('intro')}>
              <div className={cx('intro-text')}>
                {this.props.introText}
              </div>
            </div>
            <div className={cx('mixer')}>
              <MixRow ref='melody' {...this.props} channel='melody' prompt='Choose A Melody' />
              <MixRow ref='ambience' {...this.props} channel='ambience' prompt='Choose An Ambience' />
              <MixRow ref='effect' {...this.props} channel='effect' prompt='Choose An Effect' />
            </div>
            <div className={cx('play-area')}>
              <div className={cx('play-title')}>Your Sound Mix</div>
              <div className={cx('play')}>
                <div className={cx('play-target', 'play-mix')} onClick={(e) => {
                  this.animate()
                  this.props.playMix(this.props.scene)
                }}>
                  <div className={cx('play-arrow')} />
                  <div className={cx('play-legend')}>Play</div>
                </div>
                <Link {...this.props} to={this.props.nextSceneUri} className={cx('submit-target')}>Submit</Link>
              </div>
            </div>
          </div>
          <div className={cx('speaker-column')}>
            <div className={cx('animation')}> <img src={trashBots[this.props.scene].anim} style={{marginTop: trashBots[this.props.scene].y, visibility: (this.state.animating ? 'visible' : 'hidden')}} /></div>
            <div className={cx('speaker')}> <img src={trashBots[this.props.scene].bot} /></div>
          </div>
        </div>
      </div>
    )
  }
}

export class PowerUp extends React.Component {
  render () {
    return <Scene
      {...this.props}
      introText={'Mix three sounds for Trash Bot to play when powering up.'}
      scene='powerUp'
      nextSceneUri='warning' />
  }
}

export class Warning extends React.Component {
  render () {
    return <Scene
      {...this.props}
      introText='Mix three sounds for Trash Bot to play when approaching a cyclist.'
      scene='warning'
      nextSceneUri='eating' />
  }
}

export class Eating extends React.Component {
  render () {
    return <Scene
      {...this.props}
      introText='Mix three sounds for Trash Bot to play after swallowing a piece of trash.'
      scene='eating'
      nextSceneUri='power_down' />
  }
}

export class PowerDown extends React.Component {
  render () {
    return <Scene
      {...this.props}
      introText="Mix three sounds for Trash Bot to play when it's time to go to sleep."
      scene='powerDown'
      nextSceneUri='day_in_the_life' />
  }
}

const sceneList = ['powerUp', 'warning', 'eating', 'powerDown']
const channelList = ['melody', 'ambience', 'effect']
const soundList = ['a', 'b']

export class SampleTree extends React.Component {
  playMix = (scene, melody, ambience, effect) => {
    const map = {
      melody: melody,
      ambience: ambience,
      effect: effect,
    }
    const audios = []
    channelList.map((channel) => {
      const ref = scene + '_' + channel + '_' + map[channel]
      const audio = this.refs[ref]
      if (audio) {
        audios.push(audio)
      }
    })
    const prepare = (audio) => {
      if (!audio.paused) {
        audio.pause()
      }
      if (audio.duration > 0) {
        audio.currentTime = 0
      }
    }
    const play = (audio) => {
      setTimeout(() => audio.play(), 25)
    }
    audios.map((audio) => prepare(audio))
    audios.map((audio) => play(audio))
  }

  play = (scene, channel, sound) => {
    const ref = scene + '_' + channel + '_' + sound
    const audio = this.refs[ref]
    if (sound) {
      if (!audio.paused) {
        audio.pause()
      }
      if (audio.duration > 0) {
        audio.currentTime = 0
      }
      setTimeout(() => audio.play(), 25)
    }
  }
  shouldComponentUpdate = (nextProps, nextState) => {
    // This component doesn't update
    return false
  }
  audioTags = () => sceneList.map((scene) =>
    channelList.map((channel) =>
      soundList.map((sound) =>
        <audio
          ref={scene + '_' + channel + '_' + sound}
          src={sounds[scene][channel][sound]}
          preload='auto'
        />
      )
    )
  )
  render () {
    return <div>
      {this.audioTags()}
    </div>
  }
}

export class DayInTheLife extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      infoDisplay: 'block',
    }
  }
  render () {
    return <div className={cx('client')}>
      <div className={cx('home')}>
        <div style={{margin: '15px', marginBottom: '10px', fontSize: '60px', fontWeight: 900}}>A DAY WITH TRASH BOT</div>
        <div style={{display: this.state.infoDisplay}}>
          <div style={{fontWeight: 400, fontSize: '40px'}}>This animation has the sounds that you designed.</div>
          <div style={{fontWeight: 400, fontSize: '40px'}}>Notice how your sounds support Trash Bot’s actions and personality.</div>
        </div>
      </div>
      <div style={{display: 'flex'}}>
        <div className={cx('play_movie_button')} style={{margin: '70px'}}>
          <div className={cx('play-target')} onClick={() => {
            this.setState({infoDisplay: 'none'})
            const video = this.refs.dayVideo
            if (video.duration > 0 && !video.paused) {
              video.pause()
              video.currentTime = 0
            }
            video.play()
            this.cancelable = this.cancelable || []
            this.cancelable.forEach((timeout) => {
              clearTimeout(timeout)
            })
            this.cancelable.push(setTimeout((e) => this.props.playMix('powerUp'), 5000))
            this.cancelable.push(setTimeout((e) => this.props.playMix('warning'), 10000))
            this.cancelable.push(setTimeout((e) => this.props.playMix('eating'), 15000))
            this.cancelable.push(setTimeout((e) => this.props.playMix('powerDown'), 20000))
          }}>
            <div className={cx('play-anim-arrow')} />
            <div className={cx('play-anim-legend')}>Play</div>
          </div>
        </div>
        <div className={cx('start_over_button')} style={{margin: '70px', cursor: 'pointer'}} onClick={(e) => {
          setTimeout((e) => window.location.reload(true), 100)
        }}>
          <div>Start Over</div>
        </div>
      </div>
      <video style={{width: '100%'}} ref='dayVideo' src={dayVideo} preload='auto'>
        <source
          src={dayVideo}
          type='video/mp4' />
      </video>
    </div>
  }
}

export class NotFound extends React.Component {
  render () {
    return (
      <div className={cx('page')}>
        <h4>Not found</h4>
      </div>
    )
  }
}

/**
 * NOTE: As of 2015-11-09 react-transform does not support a functional
 * component as the base compoenent that's passed to ReactDOM.render, so we
 * still use createClass here.
 */
export class App extends React.Component {

  constructor (props) {
    super(props)
    this.state = initialState
    this.touchTimeout()
  }

  setUri = (uri) => {
    this.touchTimeout()
    this.setState({
      uri: uri,
    })
  }

  setSound = (scene, channel, sound) => {
    this.touchTimeout()
    const change = {
      ...this.state[scene],
    }
    change[channel] = sound
    const stateChange = {}
    stateChange[scene] = change
    if (sound !== null) {
      this.refs.sampleTree.play(scene, channel, sound)
    }
    this.setState(stateChange)
  }

  getSounds = () => {
    return this.state
  }

  playMix = (scene) => {
    this.touchTimeout()
    this.refs.sampleTree.playMix(
      scene,
      this.state[scene].melody,
      this.state[scene].ambience,
      this.state[scene].effect,
    )
  }

  getScene () {
    const props = {
      setSound: this.setSound,
      setUri: this.setUri,
      getSounds: this.getSounds,
      resetSounds: this.resetSounds,
      playMix: this.playMix,
    }
    switch (this.state.uri) {
    case 'home':
      return <Home {...props} />
    case 'power_up':
      return <PowerUp {...props} />
    case 'warning':
      return <Warning {...props} />
    case 'eating':
      return <Eating {...props} />
    case 'power_down':
      return <PowerDown {...props} />
    case 'day_in_the_life':
      return <DayInTheLife {...props} />
    }
  }

  handleInactivity = () => {
    if (this.state.uri === 'home') {
      // no-op on the home page,
      this.inactivity = setTimeout(this.handleInactivity, 10000)
      return
    }
    if (this.state.inactive) {
      // ok, you're done
      window.location.reload()
    } else {
      this.setState({inactive: true})
      // shorter timer to go away
      this.inactivity = setTimeout(this.handleInactivity, 10000)
    }
  }

  touchTimeout = () => {
    if (this.inactivity) {
      clearTimeout(this.inactivity)
    }
    this.inactivity = setTimeout(this.handleInactivity, 60000)
  }

  render () {
    return <div>
      {this.state.inactive ? <div className={cx('inactivity')} onClick={(e) => {
        this.setState({inactive: false})
        this.touchTimeout()
      }}>
        <div>Are you still there?</div>
      </div> : null}
      <SampleTree ref='sampleTree' />
      {this.getScene()}
    </div>
  }

}



// WEBPACK FOOTER //
// ./client/components/App.js